module.exports = __webpack_public_path__ + "img/logo-igi@2x.a0c69de.webp";